angular.module('app').factory('UtpUploadsService', function ($browser, $window, HttpHelper) {
    let fac = {
        users: users
    };
    function users(users, currentUser) {
        let usersList = _.map(users, function (item) {
            return {
                Id: item.Id,
                Name: item.Description ? item.Description : item.Name,
                CoreRole: item.Role,
                Description: item.Description ? item.Description : item.Name
            };
        });
        let currentUserItem = { Id: currentUser.Id, Name: currentUser.Description, Role: currentUser.CoreRole };
        // @ts-ignore lodash
        usersList = _.concat(currentUserItem, usersList);
        // @ts-ignore lodash
        let uniqueUsers = _.uniqBy(usersList, function (item) { return item.Id; });
        if (uniqueUsers.length === 0) {
            let resp = [{ Id: 0, Name: 'No users available', Description: '', CoreRole: '' }];
            return resp;
        }
        _.sortBy(uniqueUsers, ['Name']);
        return uniqueUsers;
    }
    return fac;
});
